import React, {useState} from "react";
import {
  InviteTeamMemberRequest,
  InviteTeamMemberResponse,
  ITeamMemberInviteProto,
  TeamMemberInviteProto
} from "../../../../provider_api";
import {RpcState} from "../../../../util/RpcState";
import {useRpcSender} from "../../../../util/RpcSender";
import {KensuObjectEditor} from "../../../../components/table/KensuObjectEditor";
import {EditableStringField} from "../../../../components/Editable/EditableStringField";

export const InviteTeamMember = () => {

  const [genInviteRpcState, setGenInviteRpcState] = useState<RpcState>({});
  const [inviteCode, setInviteCode] = useState<string>();
  const rpcSender = useRpcSender();

  const generateInvite = () => {
    // Clear the error
    setGenInviteRpcState({});

    const request = InviteTeamMemberRequest.encode(new InviteTeamMemberRequest({})).finish();

    rpcSender.send('generate_login_invite', request)
        .then(r => {
          const response = InviteTeamMemberResponse.decode(r);
          if (!response.okay) {
            setGenInviteRpcState({state: 'error', message: 'unknown error generating invite'});
            return;
          }

          setGenInviteRpcState({state: 'success'})
          // setInviteCode(response.inviteCode);
        })
        .catch(e => {
          setGenInviteRpcState({state: 'error', message: e})
        });
  }

  return <div>

    <KensuObjectEditor<ITeamMemberInviteProto, ITeamMemberInviteProto>
        idParam={undefined}
        getter={id => undefined}
        getTitle={() => undefined}
        entityName={'Invite'}
        entityListViewLink={'../logins'}
        newBlankType={() => new TeamMemberInviteProto()}
        getRpcMethod={() => 'invite_team_member'}
        getRpcPayload={workingCopy => InviteTeamMemberRequest.encode(new InviteTeamMemberRequest({
          email: workingCopy.sentToEmail
        })).finish()}
        parseRpcResponse={InviteTeamMemberResponse.decode}
        handleContainerTypeUpdate={() => {}}
    >
      
      <EditableStringField field={'sentToEmail'} 
                           errorKey={'email'}
                           label={'Email'}
                           inputType={'text'}
                           helpText={'Invite will be sent to this email'}/>

      {/*<EditableStringField field={''}*/}
      {/*                     label={'Email'}*/}
      {/*                     inputType={'text'}*/}
      {/*                     helpText={'Invite will be sent to this email'}/>*/}

      
    </KensuObjectEditor>
  </div>;
}